import * as React from "react";
import { forwardRef } from "react";
import {
  ProductResult,
  RequestSorting,
} from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { commonSortingOptions } from "../constants";
import { PaginationData, SortingChangeHandler } from "../types";
import { LoadMoreButton, LoadMoreHandler } from "./load_more_button";
import { PageChangeHandler, Pagination } from "./pagination";
import { CatalogItemBoxList } from "./catalog_item_box_list";
import { SortingTabs } from "./sorting_tabs";
import styles from "./pagination.module.sass";

type ProductListProps = {
  products: ProductResult[];
  pagination: PaginationData;
  onPageChange: PageChangeHandler;
  onLoadMore: LoadMoreHandler;
  isLoading: boolean;
  onSort: SortingChangeHandler;
  activeSorting: RequestSorting;
  membersOnlyProducts: Record<number, number>;
};

export const ProductList = forwardRef<HTMLUListElement, ProductListProps>(
  (
    {
      products,
      pagination,
      onPageChange,
      onLoadMore,
      onSort,
      activeSorting,
      isLoading,
      membersOnlyProducts,
    },
    ref
  ): JSX.Element => {
    return (
      <>
        <SortingTabs
          sortingOptions={commonSortingOptions}
          activeSorting={activeSorting}
          onSort={onSort}
        />
        <CatalogItemBoxList
          products={products}
          ref={ref}
          membersOnlyProducts={membersOnlyProducts}
        />
        <div className={styles.paginationContainer}>
          <LoadMoreButton
            {...pagination}
            onLoadMore={onLoadMore}
            isLoading={isLoading}
          />
          <Pagination {...pagination} onPageChange={onPageChange} />
        </div>
      </>
    );
  }
);
